import { Component, OnInit, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

export enum MessageType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}

@Component({
    imports: [],
    selector: 'app-message-display',
    templateUrl: './message-display.component.html',
    styleUrls: ['./message-display.component.css']
})
export class MessageDisplayComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  message: string = '';
  messageType: MessageType = MessageType.Info;
  returnUrl: string = '/';
  returnButtonText: string = $localize`Zur Startseite`;

  ngOnInit(): void {
    // Check if there's a stored profile deleted message
    const storedMessage = sessionStorage.getItem('profileDeletedMessage');
    if (storedMessage) {
      this.message = storedMessage;
      this.messageType = MessageType.Success;
      this.returnUrl = '/';
      this.returnButtonText = $localize`Zur Startseite`;
      sessionStorage.removeItem('profileDeletedMessage');
    } else {
      // Use query params
      this.route.queryParams.subscribe(params => {
        this.message = params['message'] || '';
        this.messageType = params['type'] || MessageType.Info;
        this.returnUrl = params['returnUrl'] || '/';
        this.returnButtonText = params['returnButtonText'] || $localize`Zur Startseite`;
      });
    }
  }

  navigateToReturnUrl(): void {
    this.router.navigate([this.returnUrl]);
  }

  get messageIcon(): string {
    switch (this.messageType) {
      case MessageType.Success:
        return $localize`Erfolg!`;
      case MessageType.Error:
        return $localize`Fehler!`;
      case MessageType.Warning:
        return $localize`Warnung!`;
      case MessageType.Info:
      default:
        return $localize`Info!`;
    }
  }

  get messageClass(): string {
    switch (this.messageType) {
      case MessageType.Success:
        return 'alert-success';
      case MessageType.Error:
        return 'alert-danger';
      case MessageType.Warning:
        return 'alert-warning';
      case MessageType.Info:
      default:
        return 'alert-info';
    }
  }
}
